// Interfaces
import { IBaseUploaderPreviewProps } from './interfaces'

// Styles
import styles from 'components/base/BaseUploader/base-uploader.module.scss'

// Components
import { BaseImagePreview } from 'components'

// Antd
import { Button, Collapse, Spin } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// React Lazy Load
import LazyLoad from 'react-lazyload'

// Custom Hook
import { useUploader } from 'hooks'

// Constant
import { FILE_IMAGE_EXTENSIONS } from 'constant/file.constant'

// Panel
const { Panel } = Collapse

const BaseUploaderPreview = ({
  files,
  onUpdate,
  onDelete,
  lastElement,
  updateButtonLoading,
  deleteButtonLoading,
  loading,
  featureName,
}: IBaseUploaderPreviewProps): JSX.Element => {
  // Hook
  const { t } = useTranslation()
  const { uploader_imageId, uploader_Input, uploader_onClickSingleFile } = useUploader({
    acceptedExtensions: FILE_IMAGE_EXTENSIONS,
  })

  return (
    <>
      <Spin spinning={loading}>
        {files.length > 0 && (
          <BaseImagePreview>
            <Collapse className="custom-accordion" accordion>
              <Panel header="Uploaded Images" key="1">
                <LazyLoad once>
                  <div className={`grid grid-cols-1 md:grid-cols-5 gap-8 ${styles.image}`}>
                    {files.map((file, index) => (
                      <div className="flex flex-col w-full" key={index} ref={lastElement}>
                        {/* Render Image */}
                        <a href={file?.imageUrl || ''}>
                          <img src={file?.imageUrl || ''} alt={file.imageUrl} />
                        </a>

                        {/* Plain HTML Input File */}
                        {onUpdate && uploader_Input(chosenFile => onUpdate(uploader_imageId || 0, chosenFile))}

                        {/* Render Button */}
                        <div className="flex items-center mt-2">
                          <Button
                            type="primary"
                            className="custom-button mr-2"
                            style={{ fontSize: 12, height: 30 }}
                            onClick={() => uploader_onClickSingleFile(file.id)}
                            loading={updateButtonLoading}
                            size="small"
                            block
                          >
                            {t('app.action.edit')}
                          </Button>

                          <Button
                            type="primary"
                            className="custom-button danger"
                            style={{ fontSize: 12, height: 30 }}
                            onClick={() => onDelete && onDelete(file)}
                            loading={deleteButtonLoading}
                            size="small"
                            block
                          >
                            {t('app.action.delete')}
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </LazyLoad>
              </Panel>
            </Collapse>
          </BaseImagePreview>
        )}
      </Spin>
    </>
  )
}

export { BaseUploaderPreview }
